export default __webpack_public_path__ + "static/media/svg-2.b5f05b97.svg";